import React from 'react';
import { ICertification } from '@/types';

export interface CertificationProgressProps {
  progress: ICertification['progress'];
  simulations: ICertification['simulations'];
  uuid: ICertification['uuid'];
}

export const CertificationProgress: React.FC<CertificationProgressProps> = ({
  progress,
  simulations,
  uuid,
}) => {
  const total = simulations.length + 1; // +1 for the certification simulation
  const progressPercentage = (progress / total) * 100;

  return (
    <div className="mb-8" id={`certification-progress-${uuid}`}>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-display text-section-subtitle font-bold text-semantic-text-primary">
          Certification Progress
        </h3>
        <span className="text-body font-text text-semantic-text-secondary">
          {progress} of {total} simulations complete
        </span>
      </div>
      <div className="h-2 w-full rounded-full bg-neutral-gray-300">
        <div
          className="h-2 rounded-full bg-brand-primary transition-all duration-300"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
};
